import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { toggleSwitch, popUpMenuChange } from '../../actions/index'
import { _ } from '../../functions/translator'
import { ToggleActions } from '../../constants/constants';
import ExportCertificates from '../menu/exportCertificates';

class ExportCertificatesButton extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            buttonDisabled: false,
        };
    }

    handleClick = () => {
        this.props.toggleSwitch(ToggleActions.CHANGE_CATEGORY_COMPONENT, true);
        this.props.popUpMenuChange({ show: false });
    }
    
    handleButtonStateChange = (isDisabled) => {
        this.setState({ buttonDisabled: isDisabled });
    };

    render(){

        const className = this.state.buttonDisabled ? "disabled-popup-menu-export-button" : "popup-menu-export-button";

        return (
                <div>
                    { !this.props.popUpMenu.close &&
                        <div 
                            className={`${className} card-color`} 
                            ref={ref => this.button = ref}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <ExportCertificates popUpMenu={true} onStateChange={this.handleButtonStateChange}></ExportCertificates>
                        </div>
                    }
                </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
        selectedCardsGroups : state.selectedCardsGroups,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        toggleSwitch : toggleSwitch,
        popUpMenuChange : popUpMenuChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ExportCertificatesButton)